module.exports = __webpack_public_path__ + "01_long_gold.0d9c1da4.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/papa/layer5/01_long_gold.png
// module id = yBxe
// module chunks = 0